<template>
  <!-- 顶部导航 -->
  <div class="header">

    <div class="fixed">
      <div class="items" @click="phones()">
        <img src="../assets/img/phone (1).png" width="32px" height="auto" ></img>
        <div>Tel</div>
      </div>
      <div class="items" @click="goViewPagess('/contact')">
        <img src="../assets/img/ic_eamil.png" width="32px" height="auto" ></img>
        <div>Email</div>
      </div>
      <div class="items" @click="goViewPagess('/contact')">
        <img src="../assets/img/YDUI-编写.png" width="32px" height="auto" ></img>
        <div>Message</div>
      </div>
      <div class="items" @click="topsss()">
        <img src="../assets/img/top.png" width="32px" height="auto" ></img>
        <div>Top</div>
      </div>
     </div>
    <div class="search_centers" v-show="showSearch==2" @mouseleave="leaveSerch()">
      <div class="seacrh-box">
         <div class="search-text">
            <el-input v-model="searchText" type="primary" placeholder="ENTER SEARCH CONTENT" @input="getProductList()" suffix-icon="el-icon-search" ></el-input>
            <div class="resu-box">
              <div class="items" v-for="(val,index) in searchList" :key="index" @click="goViews(('/detail/'+val.id))" >
                 <div class="title" >{{val.title}}</div>
              </div>
            </div>
         </div>
      </div>
    </div>
    <div class="container-top">
      <div class="nav-topbar">
        <div class="logo" @click="goWindowPages('/index')">
          <img src="../../public/imgs/logo.png" width="100%" height="auto" />
        </div>
        <div class="ri-nav">
          <!--
          <el-button type="text" @click="drawer = true">MENU</el-button>-->
          <div class="mobile-m" @click="drawer = true">MENU</div>
        </div>
        <div class="container">
          <div class="container-s">
          <el-menu router :default-active="$route.path" class="el-menu-demo" mode="horizontal" @select="handleSelect"
            text-color="#252525" active-text-color="#00959b">
            <el-menu-item index="/index" key="/index"
              style="margin-left: 20px;margin-right: 20px;font-weight: 600;">HOME</el-menu-item>
            <el-submenu index="/product/1" style="font-weight: 600;"@click.native="goWindowPages('/product/1')">
              <template slot="title">PRODUCTS</template>
              <el-menu-item index="/product/22">Water Pump</el-menu-item>
              <el-menu-item index="/product/38">High Pressure Washer</el-menu-item>
              <el-menu-item index="/product/37">Generator</el-menu-item>
              <el-menu-item index="/product/25">Cordless Tools</el-menu-item>
              <el-menu-item index="/product/19">Equipment</el-menu-item>
            </el-submenu>
            <el-submenu index="/news/1" key="/news" style="font-weight: 600;" @click.native="goWindowPages('/news/1')">
              <template slot="title">BOLG</template>
              <el-menu-item index="/news/14" key="/news/14">Company News</el-menu-item>
              <el-menu-item index="/news/15" key="/news/15">Industry News</el-menu-item>
            </el-submenu>
            <el-menu-item index="/download"
              style="margin-left: 20px;margin-right: 20px;font-weight: 600;">DOWNLOAD</el-menu-item>
            <el-submenu index="/about/1" style="font-weight: 600;" @click.native="goWindowPages('/about/0')" >
              <template slot="title">ABOUT</template>
              <el-menu-item index="/about/1">Company Profile</el-menu-item>
              <el-menu-item index="/about/2">Our Company</el-menu-item>
              <el-menu-item index="/about/3">Our Product</el-menu-item>
              <el-menu-item index="/about/4">Product Application</el-menu-item>
              <el-menu-item index="/about/5">Our Certificate</el-menu-item>
              <el-menu-item index="/about/6">Production Market</el-menu-item>
              <el-menu-item index="/about/7">Our Service</el-menu-item>
            </el-submenu>
            <el-submenu index="/events/1" style="font-weight: 600;" @click.native="goWindowPages('/events/1')" >
              <template slot="title">EVENTS</template>
              <el-menu-item index="/events/26">Before</el-menu-item>
              <el-menu-item index="/events/27">Future</el-menu-item>
            </el-submenu>
            <el-submenu index="/video/1" style="font-weight: 600;"@click.native="goWindowPages('/video/1')"  >
              <template slot="title">VIDEO</template>
              <el-menu-item index="/video/28">Company Video</el-menu-item>
              <el-menu-item index="/video/29">Product Video</el-menu-item>
            </el-submenu>
            <el-menu-item index="/contact"
              style="margin-left: 20px;margin-right: 20px;font-weight: 600;">CONTACT</el-menu-item>
          </el-menu>
        </div>
        </div>
        <div class="container-s-c">
          <div class="search-btn" @mouseenter="showSearch=2">
            <img src="../assets/img/search.png"></img>
          </div>
          <div class="contact-centers" @click="phones()">
            <span class="btn-i-phone"></span>
            <div class="contact-btn">
              +86-135-8600-1336
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-drawer title="MENU" size="80%" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
      <div class="search-s">
        <div>
          <input
            class="input"
            placeholder="Please Search"
            v-model="searchText" type="primary" @input="getProductList()"
            >
            <div class="search-btns"></div>
         </input>
        </div>
        <div class="resu-box">
          <div class="items" v-for="(val,index) in searchList" :key="index" @click="goViews(('/detail/'+val.id))" >
              <div class="title" >{{val.title}}</div>
          </div>
        </div>
      </div>
      <el-menu router :default-active="$route.path" class="el-menu-demo" @select="handleSelect" text-color="#252525"
        active-text-color="#00959b">
        <el-menu-item index="/index" key="/index" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;">HOME</el-menu-item>
        <el-submenu index="/product/1" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;" >
          <template slot="title"@click.native="goWindowPages('/product/1')" >PRODUCTS</template>
              <el-menu-item index="/product/22">Water Pump</el-menu-item>
              <el-menu-item index="/product/38">High Pressure Washer</el-menu-item>
              <el-menu-item index="/product/37">Generator</el-menu-item>
              <el-menu-item index="/product/25">Cordless Tools</el-menu-item>
              <el-menu-item index="/product/19">Equipment</el-menu-item>

        </el-submenu>
        <el-submenu index="/news" key="/news" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;"  >
            <template slot="title" @click.native="goWindowPages('/news/1')">BOLG</template>
              <el-menu-item index="/news/14" key="/news/14">Company News</el-menu-item>
              <el-menu-item index="/news/15" key="/news/15">Industry News</el-menu-item>
        </el-submenu>
        <el-menu-item index="/download" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;">DOWNLOAD</el-menu-item>
        <el-submenu index="/about" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;"  >
          <template slot="title" @click.native="goWindowPages('/about/0')">ABOUT</template>
          <el-menu-item index="/about/1">Company Profile</el-menu-item>
          <el-menu-item index="/about/2">Our Company</el-menu-item>
          <el-menu-item index="/about/3">Our Product</el-menu-item>
          <el-menu-item index="/about/4">Product Application</el-menu-item>
          <el-menu-item index="/about/5">Our Certificate</el-menu-item>
          <el-menu-item index="/about/6">Production Market</el-menu-item>
          <el-menu-item index="/about/7">Our Service</el-menu-item>
        </el-submenu>
        <el-submenu index="/events/" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;"  >
          <template slot="title" @click.native="goWindowPages('/events/1')" >EVENTS</template>
              <el-menu-item index="/events/26">Before</el-menu-item>
              <el-menu-item index="/events/27">Future</el-menu-item>
        </el-submenu>
        <el-submenu index="/video/" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;">
              <template slot="title"  @click.native="goWindowPages('/video/1')">VIDEO</template>
              <el-menu-item index="/video/29">Product Video</el-menu-item>
              <el-menu-item index="/video/28">Company Video</el-menu-item>
            </el-submenu>
        <el-menu-item index="/contact" style="font-weight: 600;width: 90%;margin: 0px auto;border-bottom: 1px solid #dfdfdf;">CONTACT</el-menu-item>
      </el-menu>
    </el-drawer>


  </div>
</template>

<script>
export default {
  name: "nav-header",
  props: ["navs", "navsitems"],
  data() {
    return {
      a: 1,
      showSearch:'1',
      searchText:'',
      searchList:[],
      b: "",
      input2:'',
      drawer: false,
      direction: 'rtl',
      defaultActive: '/index',
      nava: "",
      activea: 1,
      showsNav: false,
      phoneList: [],
    };
  },
  watch: {
    // 监听路由的变化
    $route: {
      handler(to) {
        this.setCurrentRouterHighlight(to.path)
        //this.defaultActive=to.path
      },
      deep: true,
    },
  },
  methods: {
    topsss(){
    
    document.documentElement.scrollTop = "0px";
    },
    goViewPagess(val) {
      // console.log('sssbb')
      let self = this
      self.$router.push(val);
    },
    phones(){
      window.location.href =`tel://+8613586001336`;
      //`tel://${phone}`
      // window.location.href = 'tel:+8613586001336';
    },
    goWindowPages(val) {
      let self = this
      self.$router.push(val)
      //location.reload()
    },
    handleClose(){
      this.drawer=false
    },
    leaveSerch(){
      let self = this;
      self.searchList=[]
      self.showSearch=1
    },
    setCurrentRouterHighlight(path) {
      const currentPathSplit = path.split('/')
      // this.defaultActive = `/${currentPathSplit[1]}`;
    },
    handleSelect(key, keyPath) {
      let self = this;

    },
    getProductList() {
      let self=this
      this.$api.mall.getProductList({title:self.searchText,page: 1, limit: 12 }).then((res) => {
        this.searchList = res.data.data.data;
        this.current_page = res.data.data.current_page
        this.total = res.data.data.total
      });
    },
    goViews(val){
      let self = this
      self.drawer=false
      self.searchText=''
      self.searchList=[]
      self.$router.push(val)
    },
    goViewPages(val, index) {
      let self = this;
      self.activeIndex = index
      self.$router.push(val);
    },
    goPages(val, a, b) {
      let self = this;
      self.activea = a;
      self.a = a;
      //self.nava = "";
      self.b = a;
      self.nava = b;
      this.$router.push(val);
    },
  },
};
</script>

<style lang="scss" scoped>
// @import "./../assets/scss/base.scss";
// @import "./../assets/scss/config.scss";
.el-menu.el-menu--horizontal {
  border: none !important;
}

/* 定义心跳跳动动画 */
@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.7;
  }

  50% {
    transform: scale(1.2);
    opacity: 1;
  }

  100% {
    transform: scale(1);
    opacity: 0.7;
  }
}


@media screen and (min-width: 0px) and (max-width:1024px) {

  .fixed{
    position: fixed;
    right: 0px;
    top:30%;
    z-index: 1000;
    width: 68px;
    overflow: hidden;
    
    .items:hover{
          background: #00969a;
    }
    .items{
      cursor: pointer;
      width: 100%;
      font-size: 12px;
      text-align: center;
      overflow: hidden;
      margin: 0px auto;
      color: #fff;
      padding: 8px;
      background: #252525;
      box-sizing: border-box;
    }
    
  }
  .header {
    font-family:'Rany-Light';
    z-index: 2000;
    position: fixed;
    width: 100%;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);
    .search_centers{
      display: none;
    }
    .search-s{
      width:100%;
      overflow:hidden;
      margin:0px auto;
      padding:0px;
      position:relative;
      box-sizing:border-box;
      .resu-box{
        border-radius: 8px;
        width: 100%;
        overflow: hidden;
        margin: 1px auto;
        box-sizing: border-box;
        padding: 0px;
        .items{
          width: 100%;
          background: #fff;
          overflow: hidden;
          margin: 0px auto;
          box-sizing: border-box;
          color: #252525;
          border-bottom: 1px solid #767676;
          padding: 0px 10px 0px 10px;
          line-height: 48px;
          cursor: pointer;
          .title{
            width: 100%;
            margin: 0PX auto;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }
      .search-btns{
        width:38px;
        height:50px;
        background: url(../assets/img/search-btn.png) no-repeat center;
        background-size:25px;
        position:absolute;
        cursor: pointer;
        top:0px;
        right:10px
      }

    }
    .input{
      width:100%;
      overflow:hidden;
      box-sizing:border-box;
      padding-left:12px;
      
      margin:0px auto;
      line-height:50px;
      height:50px;
      background:#ededed;
      border:none;
    }

    .container-top {
      width: 100%;
      overflow: hidden;
      margin: 0 auto;

      .ri-nav {
        float: right;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        margin-right: 20px;
        line-height: 60px;

        .mobile-m {
          overflow: hidden;
          line-height: 60px;
          height: 60px;
          background: url(../assets/img/menu.png) no-repeat left;
          padding-left: 30px;
          background-size: 26px;
        }
      }

      .container {
        display: none;
      }

      .container-s-c {
        display: none;
      }

      .contact-centers {
        display: none;
      }

      .nav-topbar {
        width: 100%;
        overflow: hidden;
        margin: 0 auto;
        background: #fff;

        .logo {
          float: left;
          width: 128px;
          cursor: pointer;
          margin-left: 20px;
          height: 60px;
          display: flex;
          vertical-align: middle;
          align-items: center;
          /* 垂直居中 */
          justify-content: center;
          /* 水平居中，如果需要的话 */
          overflow: hidden;
        }
      }
    }
  }


}

@media screen and (min-width: 1024px) and (max-width:1600px) {
  .header {
    font-family:'Rany-Light';
    z-index: 33;
    position: fixed;
    width: 100%;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);

    .fixed{
        position: fixed;
        right: 0px;
        top:30%;
        z-index: 1000;
        width: 72px;
        overflow: hidden;
        
        .items:hover{
             background: #00969a;
        }
        .items{
          cursor: pointer;
          width: 100%;
          text-align: center;
          font-size: 14px;
          overflow: hidden;
          margin: 0px auto;
          color: #fff;
          padding: 8px;
          background: #252525;
          box-sizing: border-box;
        }
        
      }
    .search_centers{
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      z-index: 100;
      position: fixed;
      top: 81px;
      left: 0px;
      .seacrh-box{
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;
        .search-text{
          width: 288px;
          overflow: hidden;
          float: right;
          margin-right: 268px;
          .resu-box{
            border-radius: 8px;
            width: 100%;
            overflow: hidden;
            margin: 1px auto;
            box-sizing: border-box;
            padding: 0px;
            .items{
              width: 100%;
              background: #fff;
              overflow: hidden;
              margin: 0px auto;
              box-sizing: border-box;
              color: #252525;
              border-bottom: 1px solid #767676;
              padding: 0px 10px 0px 10px;
              line-height: 48px;
              cursor: pointer;
              .title{
                width: 100%;
                margin: 0PX auto;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
    /**
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 0.5s ease;
  }**/
    .container-nav {
      width: 100%;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);

      .nav-centers {
        width: 1600px;
        overflow: hidden;
        margin: 0 auto;

        .navactive {
          background: #fff;

          span {
            height: 30px;
            line-height: 30px;
            margin: 14px auto;
            width: 100%;
            border-bottom: 1px solid #1d8d3b;
            display: inline-block;
          }
        }

        .nav-items {
          display: block;
          float: left;
          overflow: hidden;
          padding-left: 20px;
          padding-right: 20px;
          text-align: center;
          line-height: 60px;
          position: relative;
          cursor: pointer;
        }
      }
    }

    .container-top {
      width: 100%;
      background: #fff;
    }

    .ri-nav {
      display: none;
    }

    .nav-topbar {
      width: 100%;
      overflow: hidden;
      margin: 0 auto;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 2%;
      /**
      max-width: 1600px;
      padding-top: 10px;
      padding-bottom: 10px;
      **/

      .logo {
        float: left;
        cursor: pointer;
        width: 175px;
        height: 60px;
        display: flex;
        vertical-align: middle;
        align-items: center;
        /* 垂直居中 */
        justify-content: center;
        /* 水平居中，如果需要的话 */
        overflow: hidden;
      }

      .container-s-c {
        float: right;
        overflow: hidden;
        line-height: 60px;
        .contact-centers {
          overflow: hidden;
          margin-left: 10px;
          position: relative;
          margin-top: 5px;
          min-height: 50px;
          min-width: 88px;
          float: left;
          padding: 0px;
          padding-left: 50px;
          color: #fff;

          .contact-btn:hover {
            color: #252525;
            background: #fff;
            cursor: pointer;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
            animation: pulse 2s infinite;

          }

          .contact-btn {
            padding-left: 20px;
            padding-right: 20px;
            color: #fff;
            display: none;
            font-size: 20px;
            background: #252525;
            line-height: 50px;
            position: relative;
          }

          .contact-btn:before {
            content: "";
            position: absolute;
            height: calc(100% + 2px);
            width: calc(100% + 30px);
            top: -1px;
            right: 100%;
            background-color: #fff;
            z-index: -1;
            -webkit-transition: all 0.4s ease-out;
            transition: all 0.4s ease-out;
            border-radius: inherit;
            -webkit-clip-path: polygon(calc(100% - 30px) 0, 100% 50%, calc(100% - 30px) 100%, 0 100%, 0 0);
                    clip-path: polygon(calc(100% - 30px) 0, 100% 50%, calc(100% - 30px) 100%, 0 100%, 0 0);
          }
          .contact-btn:hover:before {
            right: -30px;
          }
          .btn-i-phone {
            width: 50px;
            position: absolute;
            top: 0px;
            z-index: 10;
            left: 20px;
            height: 50px;
            float: left;
            display: block;
            background: url("../assets/img/phone.png") no-repeat center #00959b;
            transform: skew(-20deg);
            /* 使用transform的skew属性来倾斜平行四边形 */
            transform-origin: top right;
            background-size: 50%;
          }
        }

        .search-btn {
          float: left;
          display: flex;
          align-items: center;
          cursor: pointer;
          height: 60px;
          vertical-align: middle;

          img {
            width: 32px;
            height: auto;
          }
        }
      }

      .container {
        float: left;
        //width: calc(100% - 175px - 303.39px);
        //margin-left:110px;
        overflow: hidden;
        line-height: 32px;
        .container-s{
          width: 940.58px;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          box-sizing: border-box;
        }
      }
    }
  }


}

@media screen and (min-width: 1601px) and (max-width:8000px) {

  .header {
    font-family:'Rany-Light';
    z-index: 33;
    position: fixed;
    width: 100%;
    overflow: hidden;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.12);

    .fixed{
        position: fixed;
        right: 0px;
        top:30%;
        z-index: 1000;
        width: 72px;
        overflow: hidden;
        
        .items:hover{
             background: #00969a;
        }
        .items{
          cursor: pointer;
          width: 100%;
          text-align: center;
          font-size: 14px;
          overflow: hidden;
          margin: 0px auto;
          color: #fff;
          padding: 8px;
          background: #252525;
          box-sizing: border-box;
        }
        
      }
    .search_centers{
      width: 100%;
      overflow: hidden;
      margin: 0px auto;
      z-index: 100;
      position: fixed;
      top: 81px;
      left: 0px;
      .seacrh-box{
        width: 1600px;
        overflow: hidden;
        margin: 0px auto;
        padding: 0px;
        box-sizing: border-box;
        .search-text{
          width: 288px;
          overflow: hidden;
          float: right;
          margin-right: 268px;
          .resu-box{
            border-radius: 8px;
            width: 100%;
            overflow: hidden;
            margin: 1px auto;
            box-sizing: border-box;
            padding: 0px;
            .items{
              width: 100%;
              background: #fff;
              overflow: hidden;
              margin: 0px auto;
              box-sizing: border-box;
              color: #252525;
              border-bottom: 1px solid #767676;
              padding: 0px 10px 0px 10px;
              line-height: 48px;
              cursor: pointer;
              .title{
                width: 100%;
                margin: 0PX auto;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }
          }
        }
      }
    }
    /**
  .v-enter {
    opacity: 0;
    transform: translateY(150px);
  }
  .v-enter-active {
    transition: all 0.5s ease;
  }**/
    .container-nav {
      width: 100%;
      overflow: hidden;
      background: #fff;
      box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);

      .nav-centers {
        width: 1600px;
        overflow: hidden;
        margin: 0 auto;

        .navactive {
          background: #fff;

          span {
            height: 30px;
            line-height: 30px;
            margin: 14px auto;
            width: 100%;
            border-bottom: 1px solid #1d8d3b;
            display: inline-block;
          }
        }

        .nav-items {
          display: block;
          float: left;
          overflow: hidden;
          padding-left: 20px;
          padding-right: 20px;
          text-align: center;
          line-height: 60px;
          position: relative;
          cursor: pointer;
        }
      }
    }

    .container-top {
      width: 100%;
      background: #fff;
    }

    .ri-nav {
      display: none;
    }

    .nav-topbar {
      width: 100%;
      overflow: hidden;
      margin: 0 auto;
      box-sizing: border-box;
      width: 100%;
      padding: 10px 2%;
      /**
      max-width: 1600px;
      padding-top: 10px;
      padding-bottom: 10px;
      **/

      .logo {
        float: left;
        cursor: pointer;
        width: 175px;
        height: 60px;
        display: flex;
        vertical-align: middle;
        align-items: center;
        /* 垂直居中 */
        justify-content: center;
        /* 水平居中，如果需要的话 */
        overflow: hidden;
      }

      .container-s-c {
        float: right;
        overflow: hidden;
        line-height: 60px;
        .contact-centers {
          overflow: hidden;
          margin-left: 10px;
          position: relative;
          margin-top: 5px;
          float: left;
          padding: 0px;
          padding-left: 50px;
          color: #fff;

          .contact-btn:hover {
            color: #252525;
            background: #fff;
            cursor: pointer;
            -webkit-transition: 0.6s ease-in-out;
            transition: 0.6s ease-in-out;
            animation: pulse 2s infinite;

          }

          .contact-btn {
            padding-left: 20px;
            padding-right: 20px;
            color: #fff;
            
            font-size: 20px;
            background: #252525;
            line-height: 50px;
            position: relative;
          }

          .contact-btn:before {
            content: "";
            position: absolute;
            height: calc(100% + 2px);
            width: calc(100% + 30px);
            top: -1px;
            right: 100%;
            background-color: #fff;
            z-index: -1;
            -webkit-transition: all 0.4s ease-out;
            transition: all 0.4s ease-out;
            border-radius: inherit;
            -webkit-clip-path: polygon(calc(100% - 30px) 0, 100% 50%, calc(100% - 30px) 100%, 0 100%, 0 0);
                    clip-path: polygon(calc(100% - 30px) 0, 100% 50%, calc(100% - 30px) 100%, 0 100%, 0 0);
          }
          .contact-btn:hover:before {
            right: -30px;
          }
          .btn-i-phone {
            width: 50px;
            position: absolute;
            top: 0px;
            z-index: 10;
            left: 20px;
            height: 50px;
            float: left;
            display: block;
            background: url("../assets/img/phone.png") no-repeat center #00959b;
            transform: skew(-20deg);
            /* 使用transform的skew属性来倾斜平行四边形 */
            transform-origin: top right;
            background-size: 50%;
          }
        }

        .search-btn {
          float: left;
          display: flex;
          align-items: center;
          cursor: pointer;
          height: 60px;
          vertical-align: middle;

          img {
            width: 32px;
            height: auto;
          }
        }
      }

      .container {
        float: left;
        width: calc(100% - 175px - 303.39px);
        //margin-left:110px;
        overflow: hidden;
        line-height: 32px;
        .container-s{
          width: 940.58px;
          overflow: hidden;
          margin: 0px auto;
          padding: 0px;
          box-sizing: border-box;
        }
      }
    }
  }
}
</style>